import LandingPage from "./components/LandingPage";

function DappPortfolio() {
  return (
    <>
      <LandingPage />
    </>
  );
}

export default DappPortfolio;
